module.exports = __webpack_public_path__ + "static/media/edf.e13a58e7.png";